import { Injectable } from '@angular/core'
import { CanActivate } from '@angular/router'
import { Observable } from 'rxjs/Observable'
import { Store } from '@ngrx/store'
import { map, take } from 'rxjs/operators'

import { AppState } from '../../../store'
import * as Auth from '../store/actions/auth.actions'
import * as fromStore from '../store'
import { SignalRService } from '../../signalR'

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private store: Store<AppState>, private signalRService: SignalRService) {
  }

  canActivate(): Observable<boolean> {
    return this.store.select(fromStore.getAuthState).pipe(
      take(1),
      map(auth => {
        if (!auth.access_token) {
          this.signalRService.stopAutoRefreshingToken()
          this.store.dispatch(new Auth.LoginRedirect())
          return false
        }

        this.signalRService.startConnection()
        this.signalRService.startAutoRefreshingToken()
        return true
      }))
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/guargs/auth.guard.ts